export function LogoMark({ size = 40, className = "" }) {
  return (
    <img
      src="/compasso-icon.jpg"
      alt="Compasso Cuidar"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`rounded-full object-cover shrink-0 ${className}`}
    />
  );
}

export function Logo({ compact = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={compact ? 34 : 42} />
      {!compact && (
        <div className="leading-none">
          <div className="font-heading font-extrabold text-[19px] tracking-tight">
            <span className="text-[#1F3B4D]">Compasso</span>{" "}
            <span className="text-[#0F766E]">Cuidar</span>
          </div>
          <div className="text-[10px] text-[#94A3B8] font-medium mt-0.5">
            Cuidado que continua entre as sessões
          </div>
        </div>
      )}
    </div>
  );
}
